"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userflow = _interopRequireDefault(require("../../../../../styles/userflow"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _Link = _interopRequireDefault(require("../Link"));
var Button = function Button(_ref) {
  var link = _ref.link,
    children = _ref.children,
    width = _ref.width,
    height = _ref.height;
  var styles = {
    container: {
      margin: '0 auto',
      borderCollapse: 'initial'
    },
    button: {
      fontSize: '14px',
      borderRadius: '3px',
      backgroundColor: '#ffe700',
      backgroundImage: 'linear-gradient(to bottom, #ffe700, #ffd000)',
      borderBottom: '2px solid #b27e01',
      textAlign: 'center',
      height: height && "".concat(height, "px")
    },
    link: {
      display: 'table',
      width: '100%',
      height: '100%'
    },
    innerLink: {
      color: _userflow["default"].colors.black,
      fontWeight: 500,
      display: 'table-cell',
      textAlign: 'center',
      verticalAlign: 'middle'
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    width: width,
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: styles.button
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: link,
    style: styles.link,
    innerStyle: styles.innerLink
  }, children)));
};
Button.defaultProps = {
  width: 225,
  height: 50
};
Button.propTypes = {
  children: _propTypes["default"].node.isRequired,
  link: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number
};
var _default = exports["default"] = Button;